import { en } from './en'
import { fr } from './fr'

export const onboardingPage = {
  en,
  fr
}